import { createSelector } from 'reselect';

const selectAccountReducer = state => state.account;

export const selectAccount = createSelector(selectAccountReducer, account => account);

export const selectAccountId = createSelector(selectAccountReducer, account => account?.id);

export const selectAccountUsername = createSelector(
  selectAccountReducer,
  account => account?.username
);

export const selectAccountName = createSelector(selectAccountReducer, account => account?.name);

export const selectAccountIsAdmin = createSelector(
  selectAccountReducer,
  account => account?.is_admin
);
